exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1IWVYfqoPl1adbcJlDHtc8{font-weight:400}._1eSh324ztBfMNHjPhNUI57{font-weight:600}._38PZ9VZ9_u-sX7B_t8PYvR{font-weight:900}\n", ""]);

// exports
exports.locals = {
	"regular": "_1IWVYfqoPl1adbcJlDHtc8",
	"bold": "_1eSh324ztBfMNHjPhNUI57",
	"bolder": "_38PZ9VZ9_u-sX7B_t8PYvR"
};